import { createMutationHelper } from '@utils/swr'
import { type LoginByPasswordRequest } from '../../../types/apiRequest'
import { type LoginByPasswordResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['wordpressLogin'], LoginByPasswordResponse, LoginByPasswordRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/wordpress-login',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestLoginByPassword = useMutation
